import React from "react";
import { Icon } from "@iconify/react";
import "./IconButton.scss";

const IconButton = ({
  variant,
  icon,
  onClick,
  disabled,
  className,
  title,
  type,
}) => {
  // Combine classes
  const buttonClass =
    `icon-button icon-button--${variant} ${className || ""}`.trim();

  return (
    <>
      <button
        className={buttonClass}
        onClick={onClick}
        disabled={disabled}
        // Use aria-label for accessibility, but remove title to prevent default browser tooltip
        aria-label={title}
        type={type}
      >
        <Icon icon={icon} />
      </button>
    </>
  );
};

export default IconButton;
